import { render, staticRenderFns } from "./NoContentLogs.vue?vue&type=template&id=00c092d6&"
import script from "./NoContentLogs.vue?vue&type=script&lang=js&"
export * from "./NoContentLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports